import 'angular:locale/data:zh-Hant';
import 'angular:locale/data:zh-Hans';
import 'angular:locale/data:tr';
import 'angular:locale/data:pt';
import 'angular:locale/data:ja';
import 'angular:locale/data:es';
import 'angular:locale/data:en-US';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
